import axios from 'axios'
import authInterceptor from '@/apis/interceptors/auth'
import resCodeInterceptor from '@/apis/interceptors/res-code'
import config from '@/config'

export default resCodeInterceptor(authInterceptor(axios.create({
  headers: {
    'platform': config.platform
  }
})))



// WEBPACK FOOTER //
// ./src/apis/jindashi-api/client.js